<template lang="html">
  <div class="row pt-sm-3">
    <div class="col-12 col-sm-9">
      <h5 class="mt-3">Confirmar detalles</h5>
      <CheckboxTooltip
        @change="handleEnableQuestions"
        name="enable_questions"
        :value="enableQuestions"
        label="Habilitar preguntas y respuestas" />
      <Tooltip :text="'Esta opción solo está disponible para usuarios que posean una suscripción'"
               :position="'right'"
               :noHover="publicationRightType"
               :active="showRepublicationTooltip"
               :noClose="!showRepublicationTooltip"
               @close="handleClose"
               @click.native="handleShowRepublicationTooltip"
               gray>
        <CheckboxTooltip
          @change="handleAutoRepublication"
          class="options-text"
          :disabled="!publicationRightType"
          name="auto_republication"
          :value="autoRepublication"
          label="Habilitar republicación automática" />
      </Tooltip>
      <div class="d-flex">
        <CheckboxTooltip
          @change="handleConditions"
          name="conditions"
          :value="conditions"
          label="Acepto los" />
        <router-link :to="{ name: 'terms' }" target="_blank" class="pl-1 align-self-center">términos y condiciones</router-link>
      </div>
      <hr>
      <h5 class="sell-publication-title">{{ title | capitalize }}</h5>
      <p class="sell-publication-price">
        <span v-if="currencyValue">
          {{ currencyCode === 'USD' ? 'U$S' : '$' }}
          {{ currencyValue | currency | nosymbol }}
        </span>
        <span v-else>consultar</span>
      </p>
      <GalleryDisplay v-if="hasImages" />
      <br>
      <AttributesList />
      <div class="mt-4" style="white-space: pre-line;">{{ body }}</div>
      <span v-if="!editingPub && !publicationRightType"
        class="d-inline-block w-100 text-center text-secondary pt-2" style="font-size: 1rem; font-style: italic;">
        <hr>
        {{remainingPubsMessage}} - <a href="#" @click.prevent="moreInfo">más info</a>
      </span>
      <hr>
      <div class="col-12 ml-auto d-block d-sm-none">
        <SquaredButton
          class="btn-block"
          @click="handlePublishAndHighlight"
          styleType="info"
          label="Publicar y Destacar" />
        <div class="text-center pt-2">
          <i class="text-secondary">(Destacá desde <strong>{{ cheapestHighlight | currency }}</strong>)</i>
        </div>
      </div>
      <div class="mt-4 mb-2 mb-sm-0 text-center d-flex">
        <div class="mx-auto ml-sm-auto mr-sm-2" style="max-width: 20rem">
          <SquaredButton
            @click="forSale == 1 ? $emit('goToDetailPayment') : $emit('goToPrice')"
            styleType="link"
            label="Anterior" />
          <SquaredButton
            v-show="true"
            :isWaiting="isFetching"
            :disabled="!readyConfirmation"
            @click="handlePublish"
            styleType="primary"
            :label="editingPub ? 'Finalizar' : 'Publicar'" />
          <br>
        </div>
        <div class="mr-auto ml-2 d-none d-sm-block">
          <SquaredButton
            :isWaiting="isFetching"
            :disabled="!readyConfirmation"
            class="d-sm-inline-block"
            @click="handleButtonPublishAndHighlight"
            styleType="info"
            :label="editingPub ? 'Finalizar y Destacar' : 'Publicar y Destacar'" />
          <br>
          <span class="d-sm-inline-block pt-2">
            <i class="text-secondary">(Destacá desde <strong>{{ cheapestHighlight | currency }}</strong>)</i>
          </span>
        </div>
      </div>
      <FlashMessage
        @close="publishErrors.active = false"
        :title="publishErrors.title"
        :content="publishErrors.content"
        closable
        :active="publishErrors.active" />
    </div>
    <div class="col-12 col-sm-3 pt-3 d-none d-sm-block">
      <div class="keep-sticky">
        <h5 class="text-center">Recibí 20 veces más visitas <strong>destacando tu publicación</strong><sup>*</sup></h5>
        <img width="100%" :src="rocketSrc" alt="">
        <h6 class="text-center my-2" style="font-size: 90%"><sup>*</sup>estimación aproximada de acuerdo a publicaciones anteriores</h6>
        <div class="mx-auto pt-2 text-center">
          <SquaredButton
            :isWaiting="isFetching"
            :disabled="!readyConfirmation"
            @click="handleStickyPublishAndHighlight"
            styleType="info"
            :label="editingPub ? 'Finalizar y Destacar' : 'Publicar y Destacar'" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import store from '@/store'
import { mapState, mapGetters } from 'vuex';
import AttributesList from '@/pages/sellPage/AttributesList'
import {instance as actionDialog} from '@/components/layout/ActionDialog'

export default {
  components: {
    GalleryDisplay: () => import('@/pages/sellPage/gallery/GalleryDisplay'),
    AttributesList
  },

  props: {
    readyConfirmation: Boolean
  },

  data: () => ({
    publishErrors: {
      active: false,
      title: '',
      content: ''
    },
    isFetching: false,
    showRepublicationTooltip: false
  }),

  computed: {

    ...mapGetters('user', ['isCommerce']),

    // FIXME: use mapGetters y mapState
    id: () => store.state.sell.id,

    enableQuestions: () => store.state.sell.enable_questions,

    autoRepublication: () => store.state.sell.auto_republication,

    conditions: () => store.state.sell.conditions,

    title: () => store.state.sell.title,

    body: () => store.state.sell.body,

    currencyCode: () => store.state.sell.price.currency_code,

    currencyValue: () => store.state.sell.price.currency_value,

    hasImages: () => store.state.sell.images.length > 0,

    paymentNeeded: () => store.state.sell.type === 'ADDITIONAL',

    limitOnCat: () => store.state.sell.limit_on_category,

    remainingPubs: () => store.state.sell.remaining_publications,

    remainingPubsMessage () {
      const postedPubs = this.limitOnCat - this.remainingPubs
      const postedPart = postedPubs === 1 ?
        'Hiciste 1 publicación. ' :
        `Hiciste ${postedPubs} publicaciones. `
      const remainingPart = this.remainingPubs === 1 ?
        'Te queda 1 publicación gratuita en esta categoría' :
        `Te quedan ${this.remainingPubs} publicaciones gratuitas en esta categoría`

      if (postedPubs === 0) {
        return remainingPart
      }
      else if (this.remainingPubs <= 0) {
        return 'No te quedan publicaciones gratuitas en esta categoría'
      } else {
        return postedPart + remainingPart
      }
    },

    editingPub () { return this.$route.name === 'editPublication' },

    rocketSrc () { return this.$CDN_STATIC + '/static/img/rocket.png' },

    publicationRightType () { return store.state.sell.type === 'PUBLICATION_RIGHT' && this.isCommerce },

    cheapestHighlight: () => store.state.sell.highlightsCalc && store.state.sell.highlightsCalc.total,

    forSale: () => store.state.sell.forSale,
  },

  methods: {
    handlePublish () {
      if (this.editingPub) {
        this.$router.push({name: 'userPublications'})
        this.pushToDataLayer('Sell page', 'Edit finish button')
      } else {
        this.pushToDataLayer('Sell page', 'Publish button')
        if (this.paymentNeeded) {
          return this.publish()
            .then(() => { this.goToHighlights(this.id) })
        } else {
          return this.publish()
            .then(() => {
              this.$emit('changeScreen', 'online')
              store.dispatch('sell/resetInitialState')
            })
        }
      }
    },

    handlePublishAndHighlight () {
      if (this.editingPub) {
        this.goToHighlights(this.id, true)
      } else {
        this.publish()
          .then(() => { this.goToHighlights(this.id,true) })
      }
    },

    handleStickyPublishAndHighlight () {
      if (!this.editingPub)
        this.pushToDataLayer('Sell page', 'Edit finish and highlight float')
      else
        this.pushToDataLayer('Sell page', 'Publish and highlight float')
      this.handlePublishAndHighlight()
    },

    handleButtonPublishAndHighlight () {
      if (!this.editingPub)
        this.pushToDataLayer('Sell page', 'Edit finish and highlight button')
      else
        this.pushToDataLayer('Sell page', 'Publish and highlight button')
      this.handlePublishAndHighlight()
    },

    publish () {
      this.isFetching = true

      return store.dispatch('sell/changePubStatusId', 1)
        .catch(this.handleErrors)
        .finally(() => { this.isFetching = false })
    },

    goToHighlights (id, highlight) {
      const query = highlight ? { highlight: highlight } : {}
      this.$router.push({ name: 'highlights', params: { id, screen: 'opciones' }, query })
    },

    handleEnableQuestions () {
      store.dispatch('sell/setOthers', { 'enable_questions': !this.enableQuestions })
      store.dispatch('sell/updateDraft')
    },

    handleAutoRepublication () {
      store.dispatch('sell/setOthers', { 'auto_republication': !this.autoRepublication })
      store.dispatch('sell/updateDraft')
    },

    handleConditions () {
      store.dispatch('sell/setOthers', { 'conditions': !this.conditions })
      store.dispatch('sell/updateDraft')
    },

    handleErrors (err) {
      const errorData = err.response.data

      if (Array.isArray(errorData.error) && errorData.error.indexOf('attributes') > -1) {
        // attributes reason
        this.publishErrors.content = 'Faltan campos por completar.'
      } else if (errorData.error && errorData.error.message) {
        // show backend reason
        this.publishErrors.title = 'Algo salió mal.'
        this.publishErrors.content = errorData.error.message
      } else if (errorData.error) {
        this.publishErrors.title = 'Algo salió mal.'
        this.publishErrors.content = errorData.error
      } else {
        this.publishErrors.title = 'Algo salió mal.'
      }

      this.publishErrors.active = true
    },

    moreInfo () {
      return actionDialog({
        header: 'Límites de publicaciones',
        html: true,
        statement: `Existe un límite de publicaciones gratuitas cada cierto tiempo para cada categoría (ej: Un auto cada 3 meses).
           Una vez superado dicho límite, las publicaciones tienen un costo que depende de la categoría.
           Establecimos estos límites de manera que no impacten en los usuarios particulares.
           <strong>Si tenés un comercio</strong> y necesitás publicar más avisos, podés pagar por cada aviso, o contratar un servicio para empresas con avisos ilimitados y otros beneficios a muy bajo precio.
           <strong><a href="/ayuda/contactanos" target="_blank">Contactate con el área comercial aquí</a></strong>.`
      })
    },

    handleShowRepublicationTooltip () {
      if (!this.publicationRightType)
        this.showRepublicationTooltip = true
    },

    handleClose () {
      this.$nextTick(() => {
        this.showRepublicationTooltip = false
      })
    }
  }
}
</script>

<style lang="scss">
@import '../../../scss/breakpoints';

  .sell-publication {
    &-title {
      font-size: 1.5rem;
      font-weight: bold;
    }

    &-price {
      font-size: 1.5rem;
    }
  }

  .options-text {
    font-size: 16px;
    @media screen and (max-width: map-get($grid-breakpoints, "sm")) {
      font-size: 18px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/sellPage/tabs/TabConfirmation.vue